<template>
  <div class="column" style="overflow: hidden">
    <NotFoundMeteor class="flex">
      <p>Ops! Algo deu errado.</p>
      <small><code>{{ $route.fullPath }}</code></small>
    </NotFoundMeteor>
  </div>
</template>

<script>
import NotFoundMeteor from "@/components/NotFoundMeteor";

export default {
  name: "NotFound",
  components: {
    NotFoundMeteor: NotFoundMeteor,
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/NotFound/index.vue